import { FC, default as React, useState } from 'react';
import {
	RateSheetGeneratorIndexResponse,
	RateSheetGeneratorProfileResponse
} from 'RtModels';
import { RateSheetGeneratorResource } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/resources/RateGeneratorResource';
import { RtxRateSheetGeneratorSelect } from 'RtUi/components/rtx/inputs/Select/instances/RateSheetGenerator/RtxRateSheetGeneratorSelect';
import { RtxTextInput } from 'RtUi/components/rtx/inputs/Text/RtxTextInput';
import { RtForm } from 'RtUi/components/ui/RtUiForm/RtForm';

interface IRateSheetGenerationEditorProps {
	disablePadding?: boolean;
	editMode?: RateSheetGeneratorProfileResponse;
	onCancel?: () => void;
	createMode?: boolean;
	narrow?: boolean;
	displayModes?: boolean;
	rateSheetGeneratorId: number;
}

const resource = new RateSheetGeneratorResource();

export const RateSheetGenerationEditor: FC<
	React.PropsWithChildren<IRateSheetGenerationEditorProps>
> = ({ narrow, createMode = false, displayModes = false }) => {
	const [error, setError] = useState();
	const [displayMode, setDisplayMode] = useState<boolean>(displayModes);
	const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

	const [rateSheetGeneratorId, setRateSheetGeneratorId] =
		useState<RateSheetGeneratorIndexResponse>();

	const [notes, setNote] = useState<string>();

	const resource = new RateSheetGeneratorResource();

	const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		setIsSubmitting(true);
		setError(undefined);

		try {
			await resource.createRateSheetGeneration(
				Number(rateSheetGeneratorId?.rateSheetGeneratorId),
				notes || ''
			);
			setIsSubmitting(false);
		} catch (err: any) {
			setIsSubmitting(false);
			setError(err);
		}
	};

	return (
		<RtForm
			narrow={narrow}
			createMode={createMode}
			disablePadding={!createMode}
			isSubmitting={isSubmitting}
			displayMode={displayMode}
			onSubmit={onSubmit}
			error={error}
			onChange={(dMode) => {
				setDisplayMode(dMode);
			}}
		>
			<RtxRateSheetGeneratorSelect
				label="Select Rate Sheet Generator"
				value={rateSheetGeneratorId}
				displayMode={displayMode}
				onChange={(value) => {
					if (value) {
						setRateSheetGeneratorId(value);
					}
				}}
				required
			/>
			<br />
			<br />
			<RtxTextInput
				label="Notes"
				displayMode={displayMode}
				value={notes}
				onChange={(value) => {
					setNote(value);
				}}
				placeholder="Enter any notes for this rate sheet generation"
				name="notes"
			/>
		</RtForm>
	);
};
